// Generated by Melange

import * as Buhta_conf__Config from "../../../packages/conf/lib/Config.js";
import * as Buhta_core__GlobalStateContext from "../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_router__CabinetRoute from "../../../packages/router/lib/CabinetRoute.js";
import * as Buhta_router__Common from "../../../packages/router/lib/Common.js";
import * as ReasonReactRouter from "reason-react/ReasonReactRouter.js";

function useUrl(param) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const serverUrl = Buhta_router__Common.prepareServerUrl(state.serverUrl);
  return ReasonReactRouter.useUrl(serverUrl, undefined);
}

function useClientUrl(param) {
  return ReasonReactRouter.useUrl(undefined, undefined);
}

function toAbsoluteString(route) {
  const cfg = Buhta_conf__Config.getConfig(undefined);
  return cfg.app_url + Buhta_router__CabinetRoute.toString(route);
}

const getListStateUrl = Buhta_router__CabinetRoute.getListStateUrl;

const getListStateStrUrl = Buhta_router__CabinetRoute.getListStateStrUrl;

const orgUri = Buhta_router__CabinetRoute.orgUri;

const orgRoute = Buhta_router__CabinetRoute.orgRoute;

const toString = Buhta_router__CabinetRoute.toString;

const ofUrl = Buhta_router__CabinetRoute.ofUrl;

const contextRoute = Buhta_router__CabinetRoute.contextRoute;

const navigateTo = Buhta_router__CabinetRoute.navigateTo;

const navigateWithContextTo = Buhta_router__CabinetRoute.navigateWithContextTo;

const updateBrowserLocation = Buhta_router__CabinetRoute.updateBrowserLocation;

const setUrlParams = Buhta_router__CabinetRoute.setUrlParams;

const getParamValue = Buhta_router__CabinetRoute.getParamValue;

const useParamValue = Buhta_router__CabinetRoute.useParamValue;

const dispatchPopStateEvent = Buhta_router__CabinetRoute.dispatchPopStateEvent;

const getRouterUrl = Buhta_router__Common.getRouterUrl;

const prepareServerUrl = Buhta_router__Common.prepareServerUrl;

const isProtected = Buhta_router__Common.isProtected;

const urlWithParams = Buhta_router__Common.urlWithParams;

const getCountry = Buhta_router__Common.getCountry;

const getLanguage = Buhta_router__Common.getLanguage;

const isNotFound = Buhta_router__Common.isNotFound;

const isLanding = Buhta_router__Common.isLanding;

const isApp = Buhta_router__Common.isApp;

export {
  getListStateUrl,
  getListStateStrUrl,
  orgUri,
  orgRoute,
  toString,
  ofUrl,
  contextRoute,
  navigateTo,
  navigateWithContextTo,
  updateBrowserLocation,
  setUrlParams,
  getParamValue,
  useParamValue,
  dispatchPopStateEvent,
  getRouterUrl,
  prepareServerUrl,
  isProtected,
  urlWithParams,
  getCountry,
  getLanguage,
  isNotFound,
  isLanding,
  isApp,
  useUrl,
  useClientUrl,
  toAbsoluteString,
}
/* Buhta_conf__Config Not a pure module */
